import { enums, enumsTypes } from "@shared/constants";
import { useTranslation } from "@shared/utils/internationalization";
import Icon from "./Icon.web";

interface CardIconProps {
  cardIconProps: {
    boxSize?: string;
    pb?: string;
  };
}

type CardIconReturnType = Partial<
  Record<enumsTypes.CardTypeMapIdType, JSX.Element>
>;

export const CardIconMap = ({
  cardIconProps,
}: CardIconProps): CardIconReturnType => {
  const { t } = useTranslation("common");

  return {
    [enums.CARD_TYPE_MAP.MASTERCARD.id]: (
      <Icon.MastercardLogo
        {...cardIconProps}
        aria-label={t("Mastercard icon")}
      />
    ),
    [enums.CARD_TYPE_MAP.VISA.id]: (
      <Icon.VisaLogo {...cardIconProps} aria-label={t("Visa icon")} />
    ),
    [enums.CARD_TYPE_MAP.DINERS.id]: (
      <Icon.DinersLogo {...cardIconProps} aria-label={t("Diners Club icon")} />
    ),
    [enums.CARD_TYPE_MAP.DISCOVER.id]: (
      <Icon.DiscoverLogo
        {...cardIconProps}
        aria-label={t("Discover Card icon")}
      />
    ),
    [enums.CARD_TYPE_MAP.AMEX.id]: (
      <Icon.AmexLogo
        {...cardIconProps}
        aria-label={t("American Express icon")}
      />
    ),
    [enums.CARD_TYPE_MAP.UNIONPAY.id]: (
      <Icon.UnionPayLogo {...cardIconProps} aria-label={t("Union Pay icon")} />
    ),
    [enums.CARD_TYPE_MAP.JCB.id]: (
      <Icon.JCBLogo {...cardIconProps} aria-label={t("JCB Card icon")} />
    ),
  };
};
